<div class="panel panel-default">
  <div class="panel-body">
    <nav class="navbar navbar-inverse top-nav">
      <div class="container-fluid">
        <ul class="nav navbar-nav navbar-left">
          <li>
            <a
              href="javascript:void(0);"
              (click)="fullscreen()"
              title="Fullscreen"
            >
              <strong>F</strong>
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0);"
              (click)="openSettings()"
              title="Settings"
            >
              <strong>S</strong>
            </a>
          </li>
          <li *ngIf="repeatA >= 0 || repeatB >= 0">
            <a
              href="javascript:void(0);"
              (click)="clearRepeat()"
              title="Clear repeat"
            >
              <strong *ngIf="repeatA >= 0">A</strong>
              -
              <strong *ngIf="repeatB >= 0">{{
                repeatB === repeatA ? "A" : "B"
              }}</strong>
            </a>
          </li>
        </ul>

        <ul class="nav navbar-nav navbar-right">
          <li
            role="presentation"
            [class.active]="currentTab === 'CAPTION'"
            [class.disabled]="noCaptions"
            [title]="
              noCaptions
                ? 'Captions will be available for this video soon. Stay tuned!'
                : 'Switch to captions'
            "
            (click)="changeTab('CAPTION')"
          >
            <a href="javascript:void(0);">Captions</a>
          </li>
          <li
            role="presentation"
            [class.active]="currentTab === 'COMMENT'"
            title="Switch to community notes"
            (click)="changeTab('COMMENT')"
          >
            <a href="javascript:void(0);">Notes</a>
          </li>
        </ul>
      </div>
    </nav>

    <ul
      class="caption-ul list-group"
      [class.dark-mode]="settings.darkMode"
      id="dictionariez-tooltip-container"
      data-dictionariez-tooltip-offset-top="60"
    >
      <p *ngIf="error && !loading" class="well well-sm text-danger">
        ERROR: {{ error.message || error }}
      </p>
      <div class="captionz-spinner" *ngIf="loading">
        <div class="captionz-bounce1"></div>
        <div class="captionz-bounce2"></div>
        <div class="captionz-bounce3"></div>
      </div>
      <div
        *ngIf="!loading && !lines.length"
        class="first-comment-tip"
        [class.dark-mode]="settings.darkMode"
      >
        <pre>{{ asciiCat }}</pre>
        <div *ngIf="currentTab === 'CAPTION'">
          <p>
            <a href="https://github.com/pnlpal/dictionariez" target="_blank"
              >Download Dictionariez to get captions for this video.</a
            >
          </p>
          <p>
            Dictionariez is an open-source browser extension that helps you
            learning Languages.
          </p>
          <p>Meow!</p>
        </div>
        <div *ngIf="currentTab === 'COMMENT'">
          <p>Be the first to take notes on this video.</p>
          <p>And be nice.</p>
          <p>Meow!</p>
        </div>
      </div>
      <ng-container *ngIf="!loading && lines">
        <li
          *ngFor="let line of lines; let i = index"
          class="list-group-item"
          [class]="{
            'repeat-b': i === repeatB,
            'repeat-a': i === repeatA,
            'line-in-repeat': isLineInRepeat(i)
          }"
          [attr.data-index]="i"
        >
          <span class="line-actions unselectable">
            <a
              href="javascript:void(0)"
              class="line-repeat"
              (click)="repeat(i)"
              title="Repeat this {{ Math.round(line.dur) }}''"
            >
              {{ getRepeatLetter(i) }}
            </a>
            <a
              href="javascript:void(0)"
              class="line-seek"
              [class.hidden]="settings.timestamp"
              (click)="seekToLine(i)"
              title="Seek to {{ Math.round(line.start) }}''"
            >
              ≻
            </a>
          </span>
          <a
            href="javascript:void(0)"
            class="line-timestamp unselectable"
            [class.hidden]="!settings.timestamp"
            (click)="seekToLine(i)"
            title="Seek to {{ Math.round(line.start) }}''"
            >{{ line.start | minsec }}</a
          >
          <span
            *ngIf="line.username"
            class="line-text list-group-item-text username-text"
            [innerHTML]="line.username + ':&nbsp;&nbsp;' | unescape"
          ></span>

          <span
            class="line-text list-group-item-text language-text"
            [innerHTML]="line.text"
          ></span>
          <span *ngIf="currentTab === 'CAPTION' && captionLines2[i]">
            <span *ngFor="let text of captionLines2[i].texts">
              <br />
              <span
                class="line-text list-group-item-text language-text2"
                [innerHTML]="text"
              ></span>
            </span>
          </span>
        </li>
      </ng-container>
    </ul>

    <nav
      class="navbar navbar-default navbar-fixed-bottom bottom-form-area bottom-nav"
      [class.dark-mode]="settings.darkMode"
    >
      <div
        class="container-fluid caption-tracks-container"
        *ngIf="currentTab === 'CAPTION'"
      >
        <ul
          class="nav navbar-nav navbar-right"
          [class.dropup]="isSmallScreen()"
        >
          <li class="dropdown">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle"
              data-toggle="dropdown"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="hidden-sm hidden-xs">{{
                trackName || "Languages"
              }}</span>
              <span class="visible-sm-inline visible-xs-inline"
                >Languages({{ selectedTracks.length }}/{{
                  captionTracks.length
                }})</span
              >
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
              <li *ngFor="let track of captionTracks">
                <a
                  href="javascript:void(0);"
                  (click)="changeCaption($event, track)"
                  title="{{ track.languageName }}"
                >
                  <input
                    type="checkbox"
                    aria-label="..."
                    [checked]="selectedTracks.includes(track)"
                  />
                  {{ track.languageName }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="container-fluid" *ngIf="currentTab === 'COMMENT'">
        <div class="navbar-header" *ngIf="!username">
          <a
            class="btn navbar-brand login-note-btn"
            href="/login?redirect=/captionz"
            (click)="login()"
            title="Login to take notes"
          >
            <span class="glyphicon glyphicon-log-in" aria-hidden="true"></span>
            Login to take notes
          </a>
        </div>

        <div class="navbar-header" *ngIf="username">
          <span class="user-info">
            <img
              *ngIf="userPicture"
              [src]="userPicture"
              alt="Profile"
              class="profile-img"
            />
            {{ username + ":&nbsp;" }}</span
          >
        </div>

        <div class="form-wrapper" *ngIf="username">
          <div class="navbar-form" role="search">
            <div class="form-group">
              <input
                required
                [formControl]="commentCtrl"
                type="text"
                class="form-control"
                placeholder="Meow~~~"
                (keyup.enter)="comment()"
              />
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
  <app-settings
    [settings]="settings"
    (changeFont)="changeFontSize($event)"
  ></app-settings>
</div>
